import { createFormInput, IFormInput, Rule } from '@lib/validate/form';

export const PROGRESS_MAX = 100;
export const STEPS_MAX = 7;
export const STEPS_INITIAL = 1;
export const PROGRESS_STEP = (PROGRESS_MAX / STEPS_MAX);

export interface IStepHeadline {
    headline: string
}

export interface IKVMap<V> {
    [k: string]: V
}

export interface IState {
    currentStep: number
    stepHeadlines: IKVMap<IStepHeadline>
    travelThemes: IKVMap<Array<string>>
    themes: Array<IKVMap<string>>
    userForm: {
        name: IFormInput<string>
        firstName: IFormInput<string>
        email: IFormInput<string>
        phone: IFormInput<string>
        phoneDialCode: IFormInput<string>
        dataPolicyAccepted: IFormInput<boolean>
        __datapolicy_checksum: string
        __datapolicy_type: string
    },
    country: string
    isFormSending: boolean
    isLoading: boolean
}

export const initialState: IState = {
    currentStep: STEPS_INITIAL,
    stepHeadlines: {},
    travelThemes: {},
    themes: [],
    userForm: {
        name: createFormInput('', false, Rule.length()),
        firstName: createFormInput('', false, Rule.length()),
        email: createFormInput('', false, Rule.length(), Rule.email),
        phone: createFormInput('', false, Rule.length()),
        phoneDialCode: createFormInput(''),
        dataPolicyAccepted: createFormInput<boolean>(false, false, Rule.truthy),
        __datapolicy_checksum: '',
        __datapolicy_type: ''
    },
    country: '',
    isFormSending: false,
    isLoading: false
};
